import React from "react";
import moment from "moment";
import { useIntl, defineMessages } from "react-intl";

import { useActionStyles } from "../header/mainHeader";
import Button from "../common/button/button";
import DownloadIcon from "../common/icons/downloadIcon";

import { filterRows, getRowValue } from "../common/dataList/dataListHelper";

const messages = defineMessages({
    export: {
        id: "main-header.export",
        defaultMessage: "Export",
        description: "Export main header toottip",
    },
});

export const Export = ({ data, fieldlist, filter }) => {
    const intl = useIntl();
    const classes = useActionStyles();
    const fieldsToExport = fieldlist.slice(1); // Don't export the first column (it's just the coloured tab)
    return (
        <Button tertiary onClick={() => save("work order list.csv", buildCSV(intl, data, fieldsToExport, filter))}>
            <DownloadIcon title={intl.formatMessage(messages.export)} />
            <span>{intl.formatMessage(messages.export)}</span>
        </Button>
    );
};

const mapFieldToValue = (row, field) => {
    let param;
    if (field.field === "workOrderDetail.relatedId") {
        param = { value: row.workOrderDetail.relatedId };
    } else if (field.field === "workOrderDetail.sourceTicketId") {
        param = { value: row.workOrderDetail.sourceTicketId };
    } else {
        param = { value: row[field.field] };
    }

    let value = "";
    if (param.value === undefined) {
        // Locates/other objects end up here
        if (row?.locates?.results?.length > 0 && row?.locates?.results[0][field?.field] !== undefined) {
            param = { value: row.locates.results[0][field.field] };
        } else if (row.workOrderDetail && row.workOrderDetail[field.field] != undefined) {
            param = { value: row.workOrderDetail[field.field] };
        } else if (row.followUpType && row.followUpType[field.field]) {
            param = { value: row.followUpType };
        } else if (field.field === "cost") {
            const skuList =
                row?.skuList?.results?.length > 0 ? row?.skuList?.results?.map((e) => e?.cost).reduce((a, b) => Number(a) + Number(b), 0) : "0";
            param = { value: skuList?.toString() };
        } else {
            param = { value: "" };
        }
    }
    if (field.excelFormatter) {
        value = field.excelFormatter(param);
    } else if (field.valueFormatter) {
        value = field.valueFormatter(param);
    } else {
        value = param.value;
    }
    return `"${value ?? ""}"`;
};

const buildCSV = (intl, rows, fieldlist, filter) => {
    var csvString = "";
    // Create headers
    csvString += fieldlist
        .filter((field) => field.field)
        .map((field) => intl.formatMessage(field.label))
        .join(",");

    csvString += "\n";

    // create rows
    filterRows(rows, filter).forEach((row) => {
        csvString += fieldlist
            .filter((field) => field.field)
            .map((field) => mapFieldToValue(row, field))
            .join(",");

        csvString += "\n";
    });

    return csvString;
};

const dateFilter = (row, start, end) => {
    if (row.resourceAssignedTo) {
        //return row.taskAssignedDate >= start && row.taskAssignedDate <= end
        return row.scheduledDate >= start && row.scheduledDate <= end;
    } else {
        return row.dueDate >= start && row.dueDate <= end;
    }
};

const save = (filename, data) => {
    var blob = new Blob(["\uFEFF" + data], { type: "text/csv; charset=utf-8" });
    if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, filename);
    } else {
        var elem = window.document.createElement("a");
        elem.href = window.URL.createObjectURL(blob);
        elem.download = filename;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
    }
};

export default Export;
